<template lang="pug">
  section.section.taste-secrets#taste-secrets
    SectionTitle(:text="title", :description="description", number="2", isContrast)
    .container
      .secrets
        .secrets__secret.secret(v-for="secret in secrets")
          picture.secret__image
            source(:srcset="require(`@/assets/${secret.imageHD}`)" media="(min-width: 2100px)")
            img(:src="require(`@/assets/${secret.image}`)", :alt="secret.title", v-fade, :data-delay="secret.fadeDelay")
          .secret__details
            h3.secret__title
              span(v-fade, :data-delay="secret.fadeDelay") {{ secret.title }}
            .secret__description(v-fade, :data-delay="secret.fadeDelay") {{ secret.description }}
</template>

<script>
import SectionTitle from "./SectionTitle.vue";

export default {
  name: "TasteSecret",
  components: {
    SectionTitle
  },
  data() {
    return {
      title: "Секрет вкуса",
      description:
        "Мы очень серьёзно относимся к производству наших напитков, но это не значит, что вы так же серьёзно должны относиться ко всему остальному.",
      secrets: [
        {
          title: "Контроль качества",
          description:
            "Все напитки Villa Blanca разработаны и произведены под контролем итальянских энологов-консультантов, от выращивания винограда до розлива в бутылку",
          image: "quality-control.jpg",
          imageHD: "quality-control--xxl.jpg",
          fadeDelay: "1/3"
        },
        {
          title: "Натуральные ингредиенты",
          description:
            "При создании напитков Villa Blanca используется только качественное вино и натуральные ароматизаторы, отобранные лучшими европейскими флейвористами",
          image: "natural-ingredients.jpg",
          imageHD: "natural-ingredients--xxl.jpg",
          fadeDelay: "2/3"
        },
        {
          title: "Мировой опыт",
          description:
            "Все напитки Villa Blanca производятся на современном оборудовании из Италии с использованием новейших технологий и рецептур",
          image: "experience.jpg",
          imageHD: "experience--xxl.jpg",
          fadeDelay: "3/3"
        }
      ]
    };
  }
};
</script>


<style lang="scss">
@import "../styles/main.scss";

.taste-secrets {
  @include from("lg") {
    margin-bottom: 50px;
  }
}

.secrets {
  display: flex;
  flex-flow: column nowrap;
  padding-top: 40px;

  @include from("lg") {
    flex-flow: row wrap;
    justify-content: center;
  }
  @include from("xl") {
    justify-content: space-between;
    align-items: flex-end;
    height: 580px;
    flex-flow: row nowrap;
  }
  @include from("xl") {
    height: auto;
  }
}
.secret {
  $block: &;

  width: 100%;
  position: relative;
  z-index: 5;
  margin-bottom: 30px;

  @include from("sm") {
    margin-bottom: 40px;
  }

  @include from("md") {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  @include from("xl") {
    width: 33%;
    margin: 0;
  }

  &__details {
    margin-top: 25px;
    position: relative;
  }

  &__title {
    font-family: $font-mojito;
    font-weight: normal;
    font-size: 60px;
    line-height: 39px;
    color: $color-text--contrast;
    position: absolute;
    z-index: 2;
    margin: 30px 0;
    max-width: 300px;
    left: 0;
    top: -200%;

    span {
      &:before {
        position: absolute;
        width: 270px;
        height: 96px;
        z-index: -1;
        left: -15%;
      }
    }

    @include from("sm") {
      top: -250%;
    }
    @include from("xxxl") {
      top: -100%;
    }
  }
  &__description {
    font-family: $font-carlito;
    font-size: 18px;
    line-height: 1.4;
    margin-left: 15px;

    @include from("lg") {
      width: 80%;
    }
    @include from("xl") {
      width: 100%;
    }
    @include from("xxxl") {
      font-size: 28px;
    }
  }
  &__image {
    z-index: -1;
    width: 100%;
    display: block;

    img {
      width: 100%;
    }

    @include from("lg") {
      width: 80%;
    }
    @include from("xl") {
      transform: translateX(-5%);
      width: auto;
      img {
        width: auto;
      }
    }
  }

  &:first-of-type {
    #{$block}__title {
      span {
        &:before {
          content: url("~@/assets/bg1.png");
        }
      }
    }
    #{$block}__description {
      @include from("xl") {
        width: 80%;
      }
    }
  }
  &:nth-of-type(2) {
    position: relative;

    @include from("xl") {
      margin-right: 50px;
    }

    #{$block}__image {
      @include from("xl") {
        position: absolute;
        bottom: -10%;
      }
    }
    #{$block}__details {
      margin-top: auto;
    }

    #{$block}__title {
      span {
        &:before {
          content: url("~@/assets/bg2.png");
        }
      }

      @include from("xl") {
        top: -150%;
      }
      @include from("xxxl") {
        top: -100%;
      }
    }
    #{$block}__description {
      @include from("xl") {
        color: $color-text--contrast;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
  }
  &:last-of-type {
    @include from("xl") {
      width: 25%;
    }

    #{$block}__title {
      width: 180px;
      span {
        &:before {
          content: url("~@/assets/bg3.png");
        }
      }
    }
  }
}
</style>